<template>
  <div class="profile">
    <Profile />
  </div>
</template>

<script>
import Profile from "@/components/Profile_component.vue";

export default {
  components: { Profile },
};
</script>

<style></style>
